import React from 'react'
import s from './ShareItineraryPopin.less'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import Modal from '../../genericComponents/Modal'
import SVGIcon from '../../svg/SVGIcon'
import useModal from '../../ui/useModal'
import { QRCodeSVG } from 'qrcode.react'
import iconMappy from '../../genericComponents/assets/autopromo-mappy.svg'
import iconInformation from '../../genericComponents/assets/informations.svg'
import iconPoi from '../../genericComponents/assets/poi.svg'
import { withOnlyGE } from '../../Device'
import useEventCallback from '../../utils/useEventCallback'
import debug from 'debug'
import { selectCurrentGeoentityId } from '../../../store/geoentity/geoentity.selectors'
import { useSelector } from 'react-redux'
import { generateFullRoute } from '../../router/routeUtils'
import { ROUTE_SEO_GEOENTITY } from '../../../routes'
import { PARAM_REDIRECT, REDIRECT_QRCODE } from '../../router/queryParameters.constants'

const d = debug('share')

const SharePoiPopin = () => {
  const { isModalDisplayed, hideModal } = useModal(MODAL_IDS.SHARE_POI_POPIN)
  const geoentityId = useSelector(selectCurrentGeoentityId)
  const onPopinClose = useEventCallback(hideModal)
  if (!isModalDisplayed) return null
  const poiShareUrl =
    location.origin + generateFullRoute(ROUTE_SEO_GEOENTITY, { geoentityId }, { [PARAM_REDIRECT]: REDIRECT_QRCODE })
  if (d.enabled) {
    d('poiShareUrl:', poiShareUrl)
  }

  return (
    <Modal modalId={MODAL_IDS.SHARE_POI_POPIN}>
      <div className={s.closeButton} onClick={onPopinClose}>
        <SVGIcon icon={'croix-android'} />
      </div>
      <div className={s.root}>
        <div className={s.leftPart}>
          <div className={s.qrcodeWrapper}>
            <QRCodeSVG value={poiShareUrl} fgColor="#00346b" size="128" />
          </div>
          <ol className={s.instructions}>
            <li>
              <b>Scannez le QR Code</b> avec l&apos;appareil photo de votre téléphone
            </li>
            <li>
              <b>Cliquez</b> sur le lien
            </li>
            <li>
              <b>Retrouvez</b> votre itinéraire sur votre mobile
            </li>
          </ol>
        </div>
        <div className={s.rightPart}>
          <div className={s.title}>Et hop, ce lieu est dans votre poche !</div>
          <ul className={s.advantagesList}>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={iconInformation} />
              </div>
              <div>Toutes les informations pratiques accessibles partout</div>
            </li>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={iconMappy} />
              </div>
              <div>Laissez-vous guider jusqu&apos;à destination avec le GPS</div>
            </li>
            <li className={s.advantagesItem}>
              <div className={s.advantagesIcon}>
                <SVGIcon url={iconPoi} />
              </div>
              <div>Consultez les autres lieux autour de vous</div>
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default withOnlyGE(SharePoiPopin)
